module.exports = __webpack_public_path__ + "static/media/solution-1.f8805d71.png";